import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=261a891e&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261a891e')) {
      api.createRecord('261a891e', component.options)
    } else {
      api.reload('261a891e', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=261a891e&", function () {
      api.rerender('261a891e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/pricing-guides/Items.vue"
export default component.exports